import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import { useTheme, DARK, LIGHT } from '../context/ThemeContext';
import AWSLogo from '../assets/img/AWS.png';
import HKLogo from '../assets/img/hk_icon.png';
import AILogo from '../assets/img/AI_logo.jpeg';

const educationData = [
  {
    degree: 'Master of Science in Computer Science',
    institution: 'Maharishi International University',
    year: 'Aug 2022 – Dec 2024',
    location: 'Iowa, USA',
  },
  {
    degree: 'Bachelor of Science in Computer Science',
    institution: 'University of Computer Studies',
    year: 'Jan 2013 – Sep 2017',
    location: 'Mandalay, Myanmar',
  },
];

const certificates = [
  {
    icon: AWSLogo,
    name: 'AWS Certified Cloud Practitioner',
    issuer: 'Amazon Web Services',
    year: '2024',
    colorKey: 'accentOrange',
    url: 'https://www.credly.com/badges/60f1ec07-e406-449b-b35d-d86eaa36196d',
  },
  {
    icon: HKLogo,
    name: 'Problem Solving (Intermediate)',
    issuer: 'HackerRank',
    year: '2023',
    colorKey: 'accentGreen',
    url: 'https://www.hackerrank.com/certificates/a18491babda4', 
  },
  {
    icon: AILogo,
    name: 'Elements of AI',
    issuer: 'University of Helsinki & Reaktor',
    year: '2019',
    colorKey: 'accentPurple',
    url: 'https://certificates.mooc.fi/validate/xwmv34co8b',   
  },
];

const Education = () => {
  const { isDark } = useTheme();
  const t = isDark ? DARK : LIGHT;
  const [hoveredEdu, setHoveredEdu] = useState(null);
  const [hoveredCert, setHoveredCert] = useState(null);

  return (
    <section id="education" style={{ background: t.bg, padding: '60px 0', transition: 'background 0.3s' }}>
      <Container>

        
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          {/* <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px' }}>
            Academic
          </div> */}
          <div style={{ fontSize: '26px', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px'  }}> 🎓 Education 🎓 </div>
        </div>

        
        {educationData.map((edu, i) => {
          const hovered = hoveredEdu === i;
          return (
            <div
              key={i}
              onMouseEnter={() => setHoveredEdu(i)}
              onMouseLeave={() => setHoveredEdu(null)}
              style={{
                background: t.bgAlt,
                border: `1px solid ${hovered ? t.borderHover : t.border}`,
                borderRadius: '12px',
                padding: '20px 24px',
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '18px',
                transition: 'all 0.2s',
                boxShadow: hovered ? t.shadow : 'none',
              }}
            >
              
              <div style={{
                width: '44px', height: '44px', borderRadius: '10px',
                flexShrink: 0, fontSize: '22px',
                background: `${t.accent}22`, border: `1px solid ${t.accent}44`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                🎓
              </div>
             
              <div>
                <div style={{ fontSize: '15px', fontWeight: 600, color: t.text, marginBottom: '4px' }}>
                  {edu.degree}
                </div>
                <div style={{ fontSize: '13px', color: t.accent, fontWeight: 500, marginBottom: '4px' }}>
                  {edu.institution}
                </div>
                <div style={{ fontSize: '12px', color: t.textSub }}>
                  {edu.year} · {edu.location}
                </div>
              </div>
            </div>
          );
        })}

        {/* ── Certificates ── */}
        <div style={{ marginTop: '40px' }}>
          <div style={{
            fontSize: '11px', fontWeight: 600, letterSpacing: '2px',
            textTransform: 'uppercase', color: t.textSub,
            marginBottom: '16px', paddingBottom: '10px',
            borderBottom: `1px solid ${t.border}`,
          }}>
            Certifications
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px' }}>
            {certificates.map((cert, i) => {
              const color = t[cert.colorKey];
              const hovered = hoveredCert === i;
              return (
                <div
                  key={i}
                  onMouseEnter={() => setHoveredCert(i)}
                  onMouseLeave={() => setHoveredCert(null)}
                  style={{
                    background: t.bgAlt,
                    border: `1px solid ${hovered ? color + '66' : t.border}`,
                    borderRadius: '12px',
                    padding: '18px 20px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '14px',
                    transition: 'all 0.2s',
                    boxShadow: hovered ? t.shadow : 'none',
                    transform: hovered ? 'translateY(-2px)' : 'none',
                  }}
                >
                  
                  <div style={{
                    width: '50px', height: '50px',
                    flexShrink: 0, borderRadius: '10px',
                   // background: `${color}22`, 
                   // border: `1px solid ${color}44`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    overflow: 'hidden',
                  }}>
                    {typeof cert.icon === 'string'
                      ? <img src={cert.icon} alt={cert.name} style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
                      : <span style={{ fontSize: '24px' }}>{cert.icon}</span>
                    }
                  </div>
                  {/* <div style={{
                    fontSize: '24px', width: '44px', height: '44px',
                    flexShrink: 0, borderRadius: '10px',
                    background: `${color}22`, border: `1px solid ${color}44`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    {cert.icon}
                  </div> */}
                  {/* Text */}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: 600, color: t.text, marginBottom: '3px' }}>
                      {cert.name}
                    </div>
                    <div style={{ fontSize: '12px', color: t.textSub, marginBottom: '10px' }}>
                      {cert.issuer} · {cert.year}
                    </div>
                    <a
                      href={cert.url}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        fontSize: '11px', color, fontWeight: 600,
                        textDecoration: 'none', letterSpacing: '0.5px',
                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                      }}
                      onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
                      onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
                    >
                      View Credential <BsBoxArrowUpRight />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </Container>
    </section>
  );
};

export default Education;